import { Subscription } from "rxjs";
import { Component, Input, OnInit, OnDestroy } from "@angular/core";

import { AuthProvider } from "../../providers/auth/auth";
import { RatingsProvider } from "../../providers/ratings/ratings";
import { StaffProvider } from "../../providers/staff/staff";

import { IUser } from "../../interfaces/users";
import { IRating } from "../../interfaces/ratings";
import { IStaffType } from "../../interfaces/staff";

@Component({
  selector: "user",
  templateUrl: "user.html",
})
export class UserComponent implements OnInit, OnDestroy {
  @Input() uid: string;
  @Input() showRating: boolean;
  user: IUser;
  userSubscription: Subscription;
  userDataLoaded = false;

  ratings: IRating[] = [];
  ratingsSubscription: Subscription;
  ratingsDataLoaded = false;
  ratingAverage = 0;

  staffTypesSubscription: Subscription;
  staffTypes: Array<IStaffType> = [];

  ratingStaffTypes: IStaffType[] = [];
  ratingStaffTypesDataLoaded = false;

  skillsRating = 0;
  overallRating = 0;

  constructor(
    private authProvider: AuthProvider,
    private ratingsProvider: RatingsProvider,
    private staffProvider: StaffProvider
  ) {}

  ngOnInit() {
    this.loadUserProfile(this.uid);
    this.loadUserRatings(this.uid);
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  loadUserProfile(uid: string) {
    this.userSubscription = this.authProvider.getUserByUid(uid).subscribe(
      (data) => {
        // console.log(user);
        this.user = data;
        this.userDataLoaded = true;
        return data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  loadUserRatings(uid: string) {
    this.ratingsSubscription = this.ratingsProvider
      .getUserRatings(uid)
      .subscribe(
        async (data) => {
          console.log(data);

          let total = 0;
          if (data) {
            total = data.length * 5;
          }
          console.log(`total: ${total}`);

          let score = 0;
          data.forEach((r) => {
            score = score + r.rating;
          });
          console.log(`score: ${score}`);

          if (total === 0 && score === 0) {
            console.log(`raw average: 0`);
            this.ratingAverage = 0;
          } else {
            console.log(`raw average: ${(score / total) * 5}`);
            this.ratingAverage = Math.round((score / total) * 5);
          };
          console.log(`rounded average: ${this.ratingAverage}`);

          this.populateRatingStaffTypes(
            Array.from(
              new Set(data.map((rating: IRating) => rating.staffTypeId))
            )
          );

          if (await this.ratingsProvider.getUserSkillsRatingsPromise(uid)) {
            this.skillsRating = await (
              await this.ratingsProvider.getUserSkillsRatingsPromise(uid)
            ).overallRating;
          } else {
            this.skillsRating = 0;
          }
          console.log("skillsRating", this.skillsRating);
          console.log("staffrating", this.ratingAverage);

          this.overallRating = (this.skillsRating + this.ratingAverage) / 2;

          this.ratingsDataLoaded = true;
          return data;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  populateRatingStaffTypes(ratingStaffTypes: string[]) {
    console.log(ratingStaffTypes);
    this.staffTypesSubscription = this.staffProvider.getStaffTypes().subscribe(
      (data) => {
        console.log(data);

        ratingStaffTypes.forEach((rst) => {
          let newRatingStaffType = data.find((st) => st.id === rst);
          this.ratingStaffTypes.push(newRatingStaffType);
        });
        console.log(this.ratingStaffTypes);
        this.ratingStaffTypesDataLoaded = true;
        return data;
      },
      (err) => {
        console.log(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/user/user.ts